$(function () {	
	$('#pan4').blur(function(){
		$('#preCVV').html($(this).val());
	});
});
	